// Imports:

// Styles:
import 'bootstrap/scss/bootstrap.scss';

// Main.scss should always be last, otherwise your styles can be overwrite by styles from libraries
import '../scss/main.scss';


// Common libraries: 
import $ from 'jquery';
window.jQuery = $;
window.$ = $;


// Popper - neccessary for bootstrap
import Popper from 'popper.js/dist/umd/popper.js';
window.Popper = Popper;

import 'bootstrap';

// Plugins
import './plugins/PluginLoadDependecies';
import './plugins/PluginLazyLoad';
import './plugins/PluginOutline';
import './plugins/PluginDeviceType';
import './plugins/PluginSVGConverter';

import Sticky from 'sticky-js/dist/sticky.min.js';

import lightbox from 'lightbox2/dist/js/lightbox.js';
import 'lightbox2/dist/css/lightbox.css';

// import 'selectric/public/selectric.css';
// import 'selectric/public/jquery.selectric.min.js';

import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';

// Init custom scrollbar
window.addEventListener('load', () => {
    initCustomScroll();
})

// Handle reinit on custom event
document.body.addEventListener('bw-custom-scroll-reload', () => {
    initCustomScroll();
})

function initCustomScroll() {
    // Find all elements where custom scroll should be initialized
    const scrollsContainers = document.querySelectorAll(`[data-custom-scroll='init']`);
    if (scrollsContainers.length > 0) {
        scrollsContainers.forEach(container => {
            // Check if custom srcoll has ben alread init on this container
            if (container.getAttribute("data-custom-scroll-active") != "true") {
                container.setAttribute("data-custom-scroll-active", "true");

                new SimpleBar(container, { autoHide: false });
            }
        })
    }
}

import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles

// Impoirt library to for lightbox
import 'fslightbox';

// Components:
// 
import Map from './components/ComponentMap';

// Script to handle menuPages
// Handle show/hide of menu with all pages

// Get menu element
let BwMenuPages = $("[data-item='BW-navigation-menu']");

// Check if menu exists
if (BwMenuPages.length > 0) {
    // Show/hide on button with menu icon
    $("[data-item='BW-navigation-button']").on("click", () => {
        if (BwMenuPages.length > 0) {
            // Check if menu is visible
            if (BwMenuPages.hasClass("visible") !== true) {
                // If true -> animate show
                BwMenuPages.addClass("visible");
                BwMenuPages.animate({ "opacity": "1" }, 300);
            }
            else {
                // If false -> animate hide
                BwMenuPages.animate({ "opacity": "0" }, 300, function () {
                    BwMenuPages.removeClass("visible");
                });
            }
        }
    });

    // Hide on button 'X" click
    $("[data-action='BW-navigation-hide']").on("click", () => {
        if (BwMenuPages.length > 0) {
            // Animate hide
            BwMenuPages.animate({ "opacity": "0" }, 300, function () {
                BwMenuPages.removeClass("visible");
            });
        }
    });
}


// Remove preload class on load
window.addEventListener('load', () => {

    /* Init Sticky */
    var sticky = new Sticky('[data-stick="true"]'); 

    // Init AOS animations
    window.setTimeout(() => {
        AOS.init({
            disable: 'mobile',
            duration: 1000,
            once: true,
            easing: 'ease-out-quart',
        });
    }, 500);

    // Init map
    const map_conatiner = document.querySelectorAll("[data-item='map']");
    if (map_conatiner.length > 0) {

        map_conatiner.forEach(container => {
        if ('IntersectionObserver' in window) {
            // sprawdzamy czy IntersectionObserver jest obsługiwany 
            // przez nasze przeglądarki
            let observerOptions = {
              root: null,
              rootMargin: '200px',
              threshold: 0
            };

            const lazyMapObserver = new IntersectionObserver((entries, observer) => {
                // Handle all entries (all images in this case)
                entries.forEach(async entry => {
                    
                    if (entry.isIntersecting) {
                        window.map = new Map(container, {
                            accessToken: 'pk.eyJ1Ijoid29qY2llY2hsYTEyMzQiLCJhIjoiY2t1OGRqdzZ5NGJ3NDJ3cXQzNHV4NDh3MiJ9.NRpSM1XHWzUk-3QFj63yJQ',
                            centerLatitude: container.dataset.lat,
                            centerLongitude: container.dataset.lng,
                            coordinates: markers
                        });
                    }
                })
            }, observerOptions)
          
            // Init observer for every element
            lazyMapObserver.observe(container);
          
          }
        });

       
    }


    setTimeout(function () {
        // Remove class that prevent transition
        const preload = document.querySelector("body");
        preload.classList.remove("preload");

        // hide loader
        let loader = document.querySelector("[data-item='loader']");
        let loaderStyle = document.querySelector("[data-item='loader-styles']");
        
        loader.parentNode.removeChild(loader);

        loaderStyle.parentNode.removeChild(loaderStyle);

    }, 100);
})